import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/layout.tsx");
